import * as React from "react";

function SvgHats(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g clipPath="url(#hats_svg__clip0)">
        <path d="M15.889 9.774l-1.035-4.14a2.356 2.356 0 00-1.676-1.718 2.356 2.356 0 00-2.321.611 1.213 1.213 0 01-1.714 0 2.356 2.356 0 00-2.321-.611 2.356 2.356 0 00-1.676 1.718l-1.035 4.14C1.456 10.417 0 11.435 0 12.658c0 .75.551 1.815 3.178 2.63 1.835.571 4.258.885 6.822.885s4.987-.314 6.823-.884C19.449 14.473 20 13.408 20 12.658c0-1.223-1.456-2.24-4.111-2.884zm-.724 1.936a15.116 15.116 0 01-10.33 0l.286-1.144c1.564.582 3.202.876 4.879.876 1.677 0 3.315-.294 4.879-.876l.286 1.143zM6.283 5.918a1.211 1.211 0 012.032-.563c.929.93 2.441.93 3.37 0a1.211 1.211 0 012.032.563l.876 3.502a12.77 12.77 0 01-4.593.85 12.77 12.77 0 01-4.593-.85l.876-3.502zM10 15c-5.476 0-8.828-1.437-8.828-2.343 0-.363.715-1.038 2.615-1.586l-.339 1.354c2.009.803 3.93 1.36 6.552 1.36 2.51 0 4.427-.51 6.552-1.36l-.339-1.354c1.9.548 2.615 1.223 2.615 1.586 0 .894-3.307 2.344-8.828 2.344z" />
      </g>
    </svg>
  );
}

export default SvgHats;
